// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$LiveRoom from "../Config.bs.js";
import * as Utils_Web$LiveRoom from "./Utils/Utils_Web.bs.js";
import * as Translations$LiveRoom from "../../translations/Translations.bs.js";

function auctionDetails(auctionUrl) {
  var url = Config$LiveRoom.values.bidclientUrl + auctionUrl;
  var __x = window.location;
  var lang = Translations$LiveRoom.language.contents;
  __x.replace(url + (
        lang === "En" ? "" : Utils_Web$LiveRoom.$$Location.queryStringSetField(new URL(url).searchParams.toString(), "locale", Translations$LiveRoom.languageToJs(lang))
      ));
}

export {
  auctionDetails ,
}
/* Config-LiveRoom Not a pure module */
